import { initializeApp } from "firebase/app";
import { firebaseConfig } from "constants/firebase-config.const";

const app = initializeApp(firebaseConfig);

export { app };
